module.exports = __webpack_public_path__ + "static/img/left.7bc4f4aa.png";